









































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import { ITransactionsProvider } from "@/models/providers/transactions";

@Component({
  components: {
    "transaction-row-item": () =>
      import("@/components/app/admin/transactions/transactionRowItem.vue")
  }
})
export default class TransactionsItems extends Vue {
  // Inject

  @Inject({ from: "transactionsProvider" })
  public transactionsProvider!: () => ITransactionsProvider;

  // Props

  @Prop({ default: 0 })
  public readonly skeletonCount!: number;

  // Computed

  public get transactionsData() {
    return this.transactionsProvider();
  }

  public get skeletonSize() {
    return (
      this.transactionsData.table?.data?.length ||
      this.skeletonCount ||
      (this.$store.getters["ui/isMobile"] ? 2 : 5)
    );
  }

  public get showEmptyState() {
    return !this.transactionsData.isLoading && !this.transactionsData.total;
  }

  public get showSkeletons() {
    return this.transactionsData.isLoading || !this.transactionsData.total;
  }
}
